export default __webpack_public_path__ + "static/sports_thumbnail-b9888d5a92e3eeb8e37b794c857738b7.png";